import script from "./TheInstaLogoPulse.vue?vue&type=script&setup=true&lang=js"
export * from "./TheInstaLogoPulse.vue?vue&type=script&setup=true&lang=js"

import "./TheInstaLogoPulse.vue?vue&type=style&index=0&id=06f15feb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f15feb"]])

export default __exports__